// Mirrored: web/admin/src/utils/overlayTemplate.js — keep resolve + chrome in sync.

export const OVERLAY_FALLBACK_LOCALE = "en";

export const OVERLAY_BACKGROUNDS = [
  { id: "dark", label: "Dark", color: "#0f172a", text: "#f3f4f6", link: "#5eead4" },
  { id: "black", label: "Black", color: "#000000", text: "#f3f4f6", link: "#5eead4" },
  { id: "white", label: "White", color: "#ffffff", text: "#111827", link: "#0f766e" },
  { id: "brand", label: "Teal", color: "#0f3d3d", text: "#f3f4f6", link: "#5eead4" }
];

export function overlayChrome(background) {
  return OVERLAY_BACKGROUNDS.find((item) => item.id === background) || OVERLAY_BACKGROUNDS[0];
}

export function isBlankOverlayHtml(html) {
  const raw = String(html || "");
  if (/<img\b/i.test(raw)) return false;
  const text = raw
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .trim();
  return text === "";
}

export function resolveOverlayHtml(template, locale) {
  if (!template) return "";
  if (locale && locale !== OVERLAY_FALLBACK_LOCALE) {
    const localized = template.contentLocales?.[locale];
    if (!isBlankOverlayHtml(localized)) return localized;
  }
  return template.content || "";
}
